import { useMemo } from 'react'
import { useFt } from 'hooks'
import { constants } from 'helpers'

import { defaultNavItems, theEditNavItems, bestsellersNavItems } from './data'


const useNav = () => {
  const isTheEditEnabled = useFt(constants.features.theEdit)

  return useMemo(() => {
    const extraNavItems = isTheEditEnabled ? theEditNavItems : bestsellersNavItems

    return [
      ...defaultNavItems,
      ...extraNavItems,
    ]
  }, [ isTheEditEnabled ])
}

export default useNav
